(function () {
  var root = document.querySelector('[data-sp-recs]');
  if (!root) return;

  var RECENT_KEY = 'sp_recently_viewed_v1';
  var moneyFormat = root.dataset.moneyFormat || '{{amount_no_decimals}} kr';

  function formatMoney(cents) {
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount_no_decimals';
    var decimals = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var value = (cents / 100).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, key.indexOf('comma') > -1 ? '.' : ',');
    if (key.indexOf('comma_separator') > -1 && decimals) value = value.replace(/\.(\d{2})$/, ',$1');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizeLabel(title) {
    return String(title).split(' (')[0];
  }

  function setupCarousel(block) {
    if (block.dataset.spCarousel) {
      block.spUpdate && block.spUpdate();
      return;
    }
    block.dataset.spCarousel = '1';
    var buttons = block.querySelectorAll('.sp-recs__btn');
    function activeTrack() {
      var tracks = block.querySelectorAll('[data-sp-recs-track]');
      for (var i = 0; i < tracks.length; i++) if (!tracks[i].hidden) return tracks[i];
      return tracks[0];
    }
    function update() {
      var track = activeTrack();
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      buttons.forEach(function (btn) {
        btn.disabled = btn.dataset.dir === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max;
      });
    }
    block.spUpdate = update;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var track = activeTrack();
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
        track.scrollBy({ left: Number(btn.dataset.dir) * step * 2, behavior: 'smooth' });
      });
    });
    block.querySelectorAll('[data-sp-recs-track]').forEach(function (track) {
      track.addEventListener('scroll', update, { passive: true });
    });
    window.addEventListener('resize', update);
    update();
  }

  function setupTabs(block) {
    var tabs = block.querySelectorAll('[data-sp-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.dataset.spTab;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        block.querySelectorAll('[data-sp-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.spPanel !== name;
          if (!panel.hidden) panel.scrollLeft = 0;
        });
        block.querySelectorAll('[data-sp-all]').forEach(function (link) {
          link.hidden = link.dataset.spAll !== name;
        });
        setupCarousel(block);
      });
    });
  }

  function cardHref(card) {
    var link = card.querySelector('a[href]');
    return link ? link.getAttribute('href').split('?')[0] : '';
  }

  function loadRelated() {
    var block = root.querySelector('[data-sp-recs-related]');
    if (!block) return;
    var track = block.querySelector('[data-sp-panel="similar"]');
    var limit = Number(root.dataset.limit) || 8;
    var existing = track.querySelectorAll('.sp-rc');
    if (existing.length >= 4) return;

    function finish() {
      track.querySelectorAll('[data-sp-skeleton]').forEach(function (el) { el.remove(); });
      if (!track.querySelector('.sp-rc')) {
        var brandTab = block.querySelector('[data-sp-tab="brand"]');
        if (brandTab) brandTab.click();
        else block.hidden = true;
      }
      setupCarousel(block);
    }

    fetch(root.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var result = doc.querySelector('[data-sp-recs-result]');
        if (result) {
          var seen = {};
          block.querySelectorAll('.sp-rc').forEach(function (card) { seen[cardHref(card)] = true; });
          var count = existing.length;
          Array.prototype.forEach.call(result.querySelectorAll('.sp-rc'), function (card) {
            var href = cardHref(card);
            if (count >= limit || seen[href]) return;
            seen[href] = true;
            track.appendChild(document.importNode(card, true));
            count++;
          });
        }
        finish();
      })
      .catch(finish);
  }

  function cardFromJson(p) {
    var available = p.variants.filter(function (v) { return v.available; });
    var first = available[0] || p.variants[0];
    var titles = available.map(function (v) { return v.title; }).join(' ');
    var condition = /pre-owned/i.test(titles) ? 'Pre-owned' : /\bnew\b/i.test(titles) ? 'New' : '';
    var discount = first.compare_at_price > first.price ? Math.floor(((first.compare_at_price - first.price) * 100) / first.compare_at_price) : 0;
    var img = p.images[0] ? p.images[0].split('?')[0] + '?width=600' : '';
    var alt = p.images[1] ? p.images[1].split('?')[0] + '?width=600' : '';
    var hasOnlyDefault = p.variants.length === 1 && /default title/i.test(p.variants[0].title);

    var action = '';
    if (!p.available) {
      action = '<span class="sp-rc__soldout">Sold out</span>';
    } else if (hasOnlyDefault || available.length === 1) {
      action = '<button type="button" class="sp-rc__add" data-sp-quick-add="' + available[0].id + '">' +
        (hasOnlyDefault ? 'Add to cart' : 'Add ' + escapeHtml(sizeLabel(available[0].title))) + '</button>';
    } else {
      action = '<div class="sp-rc__sizes">' + available.slice(0, 6).map(function (v) {
        return '<button type="button" class="sp-rc__size" data-sp-quick-add="' + v.id + '">' + escapeHtml(sizeLabel(v.title)) + '</button>';
      }).join('') + (available.length > 6 ? '<a class="sp-rc__size sp-rc__size--more" href="' + p.url + '">+' + (available.length - 6) + '</a>' : '') + '</div>';
    }

    return '<article class="sp-rc">' +
      '<a class="sp-rc__media" href="' + p.url + '" aria-label="' + escapeHtml(p.title) + '">' +
        (img ? '<img class="sp-rc__img" src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
        (alt ? '<img class="sp-rc__img sp-rc__img--alt" src="' + alt + '" alt="" loading="lazy">' : '') +
        '<span class="sp-rc__badges">' +
          (discount ? '<span class="sp-rc__badge sp-rc__badge--sale">-' + discount + '%</span>' : '') +
          (condition ? '<span class="sp-rc__badge">' + condition + '</span>' : '') +
        '</span>' +
      '</a>' +
      '<div class="sp-rc__body">' +
        (p.vendor ? '<p class="sp-rc__vendor">' + escapeHtml(p.vendor) + '</p>' : '') +
        '<a class="sp-rc__title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
        '<p class="sp-rc__price">' + (p.price_varies ? '<span class="sp-rc__from">From</span> ' : '') +
          '<span>' + formatMoney(p.price_min) + '</span>' +
          (discount ? '<del>' + formatMoney(first.compare_at_price) + '</del>' : '') +
        '</p>' +
        action +
      '</div>' +
    '</article>';
  }

  function loadRecent() {
    var block = root.querySelector('[data-sp-recs-recent]');
    var current = root.dataset.handle;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) {}
    list = list.filter(function (h) { return h !== current; });
    var limit = Number(root.dataset.recentLimit) || 8;

    try { localStorage.setItem(RECENT_KEY, JSON.stringify([current].concat(list).slice(0, 20))); } catch (e) {}

    if (!block || !list.length) return;
    var handles = list.slice(0, limit);
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(function (p) { return p && p.available; }).map(cardFromJson).join('');
      if (!html) return;
      block.querySelector('[data-sp-recs-track]').innerHTML = html;
      block.hidden = false;
      setupCarousel(block);
    });
  }

  function quickAdd(btn) {
    var body = { items: [{ id: Number(btn.dataset.spQuickAdd), quantity: 1 }] };
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status) {
          btn.textContent = 'Sold out';
          btn.disabled = true;
          return;
        }
        var label = btn.textContent;
        btn.classList.add('is-added');
        btn.textContent = '✓';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sp-recommendations', productVariantId: body.items[0].id, cartData: res });
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.header_cart_count').forEach(function (el) { el.textContent = c.item_count; });
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sp-quick-add]');
    if (!btn) return;
    e.preventDefault();
    quickAdd(btn);
  });

  var relatedBlock = root.querySelector('[data-sp-recs-related]');
  if (relatedBlock) {
    setupTabs(relatedBlock);
    setupCarousel(relatedBlock);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      loadRelated();
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  } else {
    loadRelated();
  }
  loadRecent();
})();
